import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';

import IssueEntry from './IssueEntry';


const ListIssues = ({ issues }) => {
  return (
    <ListGroup>
      { issues.map((issue, idx) => (
        <IssueEntry issue={ issue } key={ idx } />
      ))}
    </ListGroup>
  );
};

export default ListIssues;
